import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Classes from '../../../../common/Classes';
import ProductImage from '../../../../common/exhibitingOrganisation/ProductImage';
import {Devices,ScreenSizes} from '../../../../common/Constants';
import bundledAssets from '../../../../../images/assets.json';
import { trackImpressions } from '../../../../common/MixpanelHelper';
import mixpanelConstants from '../../../../common/mixpanelConstants';

const ProductImageInOverLay = ({
  src, alt, imageSize, translations, imageDataDtm, mixpanelProps, productIndex}) => {
  const productRef = useRef();
  const mixpanelProperties = {
    ...mixpanelProps,
    component: mixpanelConstants.component.exhibitorDirectoryOverlay,
    viewedElement: mixpanelConstants.element.productImage
  }

  useEffect(() => {
    delete mixpanelProperties.element;
    let timeoutId;
    const observer = trackImpressions(mixpanelConstants.eventName.productImpression, mixpanelProperties, 0.8);

    if (productRef.current) {
      timeoutId = setTimeout(() => {
        observer.observe(productRef.current);
      }, 500);
      return () => {
        clearTimeout(timeoutId);
        observer.disconnect();
      };
    }

  }, [productIndex]);

  return (
  <div className={Classes.imageInDirectoryContainer} ref={productRef}>
    <MediaQuery minWidth={1199}>
      <ProductImage
        src={src}
        deviceType={`${Devices.desktop}-${ScreenSizes.large}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        imageDataDtm={imageDataDtm}
        fallbackImage = {bundledAssets.defaultProductImageUrl}
        isOverlay = {true}
      />
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <ProductImage
        src={src}
        deviceType={`${Devices.desktop}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        imageDataDtm={imageDataDtm}
        fallbackImage = {bundledAssets.defaultProductImageUrl}
        isOverlay = {true}
      />
    </MediaQuery>
    <MediaQuery minWidth={768} maxWidth={991}>
      <ProductImage
        src={src}
        deviceType={`${Devices.mobile}-${ScreenSizes.large}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        imageDataDtm={imageDataDtm}
        fallbackImage = {bundledAssets.defaultProductImageUrl}
        isOverlay = {true}
      />
    </MediaQuery>
    <MediaQuery maxWidth={767}>
      <ProductImage
        src={src}
        deviceType={`${Devices.mobile}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        translations={translations}
        imageDataDtm={imageDataDtm}
        fallbackImage = {bundledAssets.defaultProductImageUrl}
        isOverlay = {true}
      />
    </MediaQuery>
  </div>
)};


ProductImageInOverLay.propTypes = {
  src: PropTypes.string.isRequired,
  imageSize: PropTypes.string.isRequired,
  alt: PropTypes.string,
  translations: PropTypes.shape({
    buttons: PropTypes.shape({
      edit: PropTypes.string
    }),
  }).isRequired,
  imageDataDtm: PropTypes.object,
  mixpanelProps: PropTypes.object,
  productIndex: PropTypes.number
};

export default ProductImageInOverLay;
